import { Mutation } from 'app/types/mutation'
import { gql } from 'graphql-request'

export const reportMutation = () => gql`
  mutation delete($id: String!, $reason: String!) {
    report(item: $id, reason: $reason) {
      id
      success
      reason
    }
  }
`

export const reportResult = (data: any) => {
  return data.report as Mutation
}
